import { Reducer } from 'redux';
import { getType } from 'typesafe-actions';
import { UI } from '../../../types/ui';
import { RootActionType } from '../../rootActions';
import {
  confirmAnnotation,
  confirmAnnotationFulfilled,
  deleteAnnotation,
  displayAnnotation,
  postponeAnnotation,
  rejectAnnotationFulfilled,
  startAnnotation,
  startAnnotationFulfilled,
} from '../annotation/actions';
import {
  onDatapointSelection,
  recountDatapointPositionFulfilled,
  selectDatapoint,
  updateDatapointValue,
  updatePosition,
} from '../datapoints/actions';
import {
  acceptSuggestedOperationsAction,
  acceptSuggestedOperationsFulfilledAction,
} from '../datapoints/suggestedOperations/actions';
import {
  applyColumnsToAllGrids,
  applyGridToNextPages,
  createGrid,
  deleteAllGrids,
  deleteGrid,
  deleteGridFulfilled,
  pasteGrid,
  updateGridAction,
  updateGridAfterExtractAllRows,
  updateGridFulfilled,
} from '../grid/actions';
import {
  alertNetworkOutage,
  cancelEditMode,
  closeSelectMenu,
  fetchEmbeddedConfigFullfiled,
  leaveValidation,
  openSelectMenu,
  setApplicationTabVisibility,
  setGridActionInProgress,
  startEditingDatapointValue,
  startEditMode,
  startValidation,
  stopEditingDatapointValue,
  toggleFooter,
} from './actions';

const initialState: UI = {
  applicationTabVisible: true,
  confirming: false,
  editModeActive: false,
  editingDatapointValue: false,
  embeddedConfig: undefined,
  footerExpanded: false,
  // magicGridMultivalueId: undefined,
  readOnly: false,
  selectMenuIsOpen: false,
  showNetworkAlert: false,
  showRejectionModal: false,
  suggestingOperations: false,
  actionInProgress: false,
  editingBbox: false,
};

const reducer: Reducer<typeof initialState, RootActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case getType(startAnnotationFulfilled):
    case getType(leaveValidation):
    case getType(startValidation):
      return {
        ...state,
        actionInProgress: false,
        readOnly: false,
        suggestingOperations: false,
      };

    case getType(confirmAnnotationFulfilled):
    case getType(postponeAnnotation):
    case getType(displayAnnotation):
    case getType(deleteAnnotation): {
      // skipRedirect doesn't exist in DISPLAY_ANNOTATION action
      return 'skipRedirect' in action.meta && action.meta.skipRedirect
        ? state
        : { ...state, readOnly: true, confirming: false };
    }

    case getType(updateDatapointValue):
    case getType(onDatapointSelection): {
      return {
        ...state,
        isSuggestingPositionsForValue: false,
      };
    }

    case getType(startEditMode):
      return { ...state, editModeActive: true };

    case getType(cancelEditMode):
      return { ...state, editModeActive: false };

    case getType(startEditingDatapointValue):
      return { ...state, editingDatapointValue: true };

    case getType(stopEditingDatapointValue):
      return { ...state, editingDatapointValue: false };

    case getType(toggleFooter):
      return { ...state, footerExpanded: !state.footerExpanded };

    case getType(openSelectMenu):
      return { ...state, selectMenuIsOpen: true };

    case getType(closeSelectMenu):
      return { ...state, selectMenuIsOpen: false };

    case getType(selectDatapoint): {
      return {
        ...state,
        selectMenuIsOpen: false,
        editingDatapointValue: false,
      };
    }

    case getType(alertNetworkOutage):
      return { ...state, showNetworkAlert: true };

    case getType(fetchEmbeddedConfigFullfiled):
      return { ...state, embeddedConfig: action.payload };

    case getType(confirmAnnotation):
      return { ...state, confirming: true };

    case getType(startAnnotation):
      return { ...state, confirming: false };

    case getType(setApplicationTabVisibility): {
      return { ...state, applicationTabVisible: action.payload };
    }

    case getType(acceptSuggestedOperationsAction): {
      return { ...state, suggestingOperations: true };
    }

    case getType(acceptSuggestedOperationsFulfilledAction): {
      return { ...state, suggestingOperations: false };
    }

    case getType(rejectAnnotationFulfilled):
      return { ...state, readOnly: true };

    case getType(updateGridAction):
      return { ...state, actionInProgress: action.meta.actionType || true };

    // TODO: Get rid of this when rewriting batch operations on grid
    case getType(setGridActionInProgress): {
      return { ...state, actionInProgress: action.payload };
    }
    case getType(createGrid):
    case getType(applyGridToNextPages):
    case getType(deleteGrid):
    case getType(deleteAllGrids):
    case getType(pasteGrid):
    case getType(applyColumnsToAllGrids):
    case getType(updateGridAfterExtractAllRows): {
      return { ...state, actionInProgress: true };
    }
    case getType(updateGridFulfilled):
    case getType(deleteGridFulfilled): {
      return { ...state, actionInProgress: false };
    }
    case getType(updatePosition): {
      return {
        ...state,
        editingBbox: true,
        isSuggestingPositionsForValue: false,
      };
    }
    case getType(recountDatapointPositionFulfilled): {
      return { ...state, editingBbox: false };
    }
    default:
      return state;
  }
};

export default reducer;
